import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../store/reducers';
import { showToast } from '../../../store/actions/toast';
import CartToastBody from './CartToastBody';
import ErrorToastBody from './ErrorToastBody';

interface ToastProp {
  dataSet: any;
}

const Toast = (props: ToastProp): JSX.Element => {
  const active = useSelector((state: RootState) => state.toast.active);
  const isShowing = useSelector((state: RootState) => state.toast.isShowing);
  const type = useSelector((state: RootState) => state.toast.type);
  const data = useSelector((state: RootState) => state.toast.data);
  const quantities = useSelector((state: RootState) => state.toast.quantities);
  const dispatch = useDispatch();

  // First display handling
  useEffect(() => {
    if (active) {
      // Reset counter and display it.
      dispatch(showToast());
    }
  }, [active]);


  // Don't render it to the DOM if the toast is inactive.
  if (!active) {
    return null;
  }

  let toastClasses = 'toast';
  if (isShowing) {
    toastClasses += ' toast--visible';
  }

  let body = null;
  switch (type) {
    case 'cart':
      body = (
        <CartToastBody
          quantities={quantities}
          productIds={data}
          cartButtonText={props.dataSet.cartButton}
          cartTitleText={props.dataSet.cartTitleText} />
      );
      break;
    case 'error':
      body = (
        <ErrorToastBody data={data} errorTitle={props.dataSet.errorTitle} errorMessage={props.dataSet.errorMessage} />
      );
      break;
    default:
      break;
  }

  return (
    <div className={toastClasses}>
      {body}
    </div>
  )
};

export default Toast
